import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import { Layout } from './components/Layout'
import { StoreProvider } from './lib/state'
import { Dashboard } from './pages/Dashboard'
import { Days } from './pages/Days'
import { Mountains } from './pages/Mountains'
import { Season } from './pages/Season'
import { SeasonPublic } from './pages/SeasonPublic'
import { TripPublic } from './pages/TripPublic'
import { Trips } from './pages/Trips'

export default function App() {
  return (
    <StoreProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route index element={<Dashboard />} />
            <Route path="mountains" element={<Mountains />} />
            <Route path="days" element={<Days />} />
            <Route path="trips" element={<Trips />} />
            <Route path="season" element={<Season />} />
          </Route>
          <Route path="s/:token" element={<SeasonPublic />} />
          <Route path="trip/:tripId" element={<TripPublic />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </StoreProvider>
  )
}
